/**
 * The probe shipment used to ask the backend for a generic carrier catalog
 * (`POST /mapitship/price-calculator`), i.e. "which companies exist and roughly
 * what do they cost" rather than "what does this order cost".
 *
 * Shared by the standalone Price Calculator page and by the bulk-assign wizard's
 * carrier picker, so the two never drift apart.
 */
export const DEFAULT_SHIPMENT_PAYLOAD = {
  origin: "Riyadh",
  destination: "Riyadh",
  boxes: [
    {
      dimensions: {
        length: 10,
        width: 10,
        height: 10,
      },
      weight: 1,
    },
  ],
  amountPayable: 0,
};

export default DEFAULT_SHIPMENT_PAYLOAD;
